import { ODataObject } from '../../interfaces/odata-model.interface';
import { JsonArrayModel } from '../../models/complex/array.model';
import { CompositeModel } from '../../models/complex/composite.model';
import { ParticipantListModel } from '../../models/complex/participant-list.model';
import {
    JsonParticipantModel,
    ODataParticipantOutModel,
    ParticipantModel,
    ParticipantModelFromJson,
} from '../../models/complex/participant.model';

export class ConfirmationParticipantsModel extends CompositeModel {
    public participantList: ParticipantListModel;
    public trainingName = '';
    public productName = '';
    public constructor(participantList: ParticipantModel[]) {
        super('ConfirmationParticipantsModel', {});
        participantList.forEach((participant) => {
            participant.setFieldValidity();
            participant.onParticipantSelectionChanged();
        });

        this.participantList = <ParticipantListModel>(
            this.set(new ParticipantListModel('CrmParticipantSet', participantList))
        );

        if (participantList.length > 0) {
            this.trainingName = participantList[0].trainingName.value;
            this.productName = participantList[0].productName.value;
        }
    }
}

export class ConfirmationParticipantsModelFromJson extends ConfirmationParticipantsModel {
    public constructor(data: JsonConfirmationParticipantsModel) {
        const participantList = data.participantList.value.map(
            (jsonParticipant: JsonParticipantModel) => new ParticipantModelFromJson(jsonParticipant),
        );
        super(participantList);
    }
}

export interface JsonConfirmationParticipantsModel {
    participantList: JsonArrayModel;
}

export interface ODataConfirmationParticipantsOutModel extends ODataObject {
    CrmParticipantSet: ODataParticipantOutModel[];
}
